<div class="container-fluid mt-3 ">
    <div class="row">
        <mat-form-field class="col-12">
            <mat-label>Code</mat-label>
            <input matInput [(ngModel)]="Model.Code" placeholder="Code" disabled>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Autres lingettes</mat-label>
            <mat-select placeholder="Autres lingettes"  (selectionChange)="copyLingette($event)">
                @for (o of LinguetteInSameInterventionList; track o; let i = $index) {
                <mat-option [value]="o">
                    <span>{{o.Localisation}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Contexte</mat-label>
            <mat-select placeholder="Contexte" [(ngModel)]="Model.Contexte" required>
                @for (o of ContexteList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Référence lot</mat-label>
            <input matInput [(ngModel)]="Model.ReferenceLot" placeholder="Référence lot">
        </mat-form-field>

        <!-- <mat-form-field class="col-12">
            <mat-label>Référence Etiquette</mat-label>
            <input matInput [(ngModel)]="Model.ReferenceEtiquette" placeholder="Référence Etiquette">
        </mat-form-field> -->

        <mat-form-field class="col-12">
            <mat-label>Témoin</mat-label>
            <input matInput [(ngModel)]="Model.Temoin" placeholder="Témoin">
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Heure de prélèvement</mat-label>
            <input matInput placeholder="Heure de prélèvement" [ngxTimepicker]="timepicker" [value]="samplingTime" [format]="24" readonly>
            <ngx-material-timepicker #timepicker (timeSet)="timeSetSamplingDate($event)"></ngx-material-timepicker>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Localisation</mat-label>
            <input matInput [(ngModel)]="Model.Localisation" placeholder="Localisation">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Type de surface</mat-label>
            <input matInput [(ngModel)]="Model.TypeSurface" placeholder="Type de surface">
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Surface de prélèvement</mat-label>
            <input matInput [(ngModel)]="Model.SurfacePrelevement" type="number" placeholder="Surface de prélèvement">
        </mat-form-field>
        <mat-checkbox [(ngModel)]="Model.VisibilitePoussiere"> Visibilite poussière</mat-checkbox>
        <mat-checkbox [(ngModel)]="Model.ApresNettoyage"> Après nettoyage</mat-checkbox>
    </div>

    <div class="row my-3">
        <button appPreventDoubleClick class="col" color="warn" mat-raised-button (throttledClick)="cancelMeasure()">
            Mesure non réalisée
        </button>
    </div>
    <div class="row">
        <button appPreventDoubleClick class="col" color="primary" mat-raised-button (throttledClick)="save()">
            Enregistrer
        </button>
    </div>
</div>